import { NavigationGuard } from 'vue-router';

import { userCanPerform, Operation } from '@/modules/common/services/partner';

export const beforeEnterWalletBuilderSelection: NavigationGuard = (
  _to,
  _from,
  next
) => {
  return userCanPerform(Operation.AdvancedBuilder)
    ? next()
    : next({ name: 'suggestedPortfolioBuilder' });
};
